class BESSAppProjectProfilerItemValueData {

    constructor(data) {
        this.isApplicable = data['applicable'];
        this.value = data['value'];
    }

    displayValue(field, emptyValue) {
        if (emptyValue === undefined) {
            emptyValue = '';
        }
        if (this.isApplicable && this.value !== null && this.value !== "") {
            switch (field.inputType) {
                case BESSAppInputType.boolean:
                    return this.value ? "Yes" : "No";

                case BESSAppInputType.percentage:
                    return '' + Math.round(parseFloat(this.value)*100.0);

                case BESSAppInputType.choice:
                    let choice = this.getChoice(field);
                    if (choice !== undefined && choice !== null) {
                        return choice.value;
                    }
                    break;
                case BESSAppInputType.map:
                    const locationData = JSON.stringify(this.value);
                    return "<div class='app-map-location' data-location='" + locationData + "'>&nbsp;</div>";
            }
            return this.value;
        }

        return emptyValue;
    }

    getChoice(field) {
        if (this.value !== null) {
            let keyValue = this.value;
            if(keyValue in field.choicesMap) {
                return field.choicesMap[keyValue];
            }
        }
        return null;
    }

    toData() {
        return {
            'applicable': this.isApplicable,
            'value': this.value,
        }
    }
}